import gql from 'graphql-tag'

const queries = {
  globalSettings: gql`
    query globalSettings {
      globalSettings {
        minimumSupportedClientVersion
        backendVersion
        winClientDownloadLink
        macosClientDownloadLink
        androidClientDownloadLink
    }
  }
  `,

  serviceStats: gql`
    query ServiceStats($timezone: String) {
      serviceStats(timezone: $timezone) {
        url
    }
  }
`,

  myOrchestrators: gql`
    query MyOrchestrators {
      myOrchestrators {
        orchestratorId,
        name,
        url,
        managementPort,
        startPort,
        endPort,
        username,
        password,
        permission,
        allowedTeams,
        attachedClusters {
          clusterId,
          name
        },       
        type,
        mediaServerStreamCount,
        sessionCount
      }
    }
  `,

  orchestratorInfo: gql`
    query OrchestratorInfo ($orchestratorId: ID!) {
      orchestratorInfo(orchestratorId: $orchestratorId) {
        orchestratorId,
        name,
        url,
        managementPort,
        startPort,
        endPort,
        username,
        password,
        permission,
        allowedTeams,
        attachedClusters {
          clusterId,
          name
        },
        type
      }
    }
  `,

  myClusters: gql`
    query MyClusters ($userRole: String) {
      myClusters(userRole: $userRole) {
        clusterId,
        name,
        permission,
        allowedTeams,
        attachedOrchestrators
      }
    }
  `,

  publicClusters: gql`
    query PublicClusters {
      publicClusters {
        clusterId,
        name
      }
    }
  `,

  clusterInfo: gql`
    query ClusterInfo ($clusterId: ID!) {
      clusterInfo(clusterId: $clusterId) {
        clusterId,
        name,
        permission,
        allowedTeams,
        attachedOrchestrators
      }
    }
  `,

  teamInventoryItems: gql`
    query TeamInventoryItems ($teamId: String, $first: Int, $offset: Int, $typeFilter: String) {
      teamInventoryItems(teamId: $teamId, first: $first, offset: $offset, typeFilter: $typeFilter) {
        inventoryItemId,
        name,
        itemUrl,
        itemType,
        teamId,
        sceneId,
        creator,
        createdDate,
        fileSize,
        thumbnailUrl,
        permission,
        creatorName,
        updatedDate,
        imageWidth,
        imageHeight,
        totalNumberOfItems
      }
    }
  `,

  sceneInventoryItems: gql`
    query SceneInventoryItems ($sceneId: String) {
      sceneInventoryItems(sceneId: $sceneId) {
        inventoryItemId,
        name,
        itemUrl,
        itemType,
        teamId,
        sceneId
      }
    }
  `,

  inventoryItemInfo: gql`
    query InventoryItemInfo ($inventoryItemId: ID!) {
      inventoryItemInfo(inventoryItemId: $inventoryItemId) {
        inventoryItemId,
        name,
        itemUrl,
        itemType,
        teamId,
        sceneId,
        creator,
        createdDate,
        fileSize,
        thumbnailUrl,
        permission,
        updatedDate,
        imageWidth,
        imageHeight
      }
    }
  `,

  myAssets: gql`
    query MyAssets ($userRole: String) {
      myAssets(userRole: $userRole) {
        assetId,
        name,
        sceneName,
        thumbnailUrl,
        allowedTeams,
        versions {
          version,
          baseUrl
        },
        linkedServerComponents {
          componentId,
          name,
          imageType
        }
      }
    }
  `,

  myTeamAssets: gql`
    query MyTeamAssets ($teamId: ID) {
      myTeamAssets(teamId: $teamId) {
        assetId,
        name,
        sceneName,
        thumbnailUrl,
        allowedTeams,
        versions {
          version,
          baseUrl
        },
        linkedServerComponents {
          componentId,
          name,
          imageType
        }
      }
    }
  `,

  assetInfo: gql`
    query AssetInfo ($assetId: ID!) {
      assetInfo(assetId: $assetId) {
        assetId,
        name,
        sceneName,
        thumbnailUrl,
        permission,
        allowedTeams,
        versions {
          version,
          baseUrl
        },
        linkedServerComponents {
          componentId,
          name,
          imageType,
          imageUrl,
          imageTag
        }
      }
    }
  `,

  sessionObjectInfo: gql`
    query sessionObjectInfo ($sessionId: String, $objectId: String) {
      sessionObjectInfo(sessionId: $sessionId, objectId: $objectId) {
        pageNumber,
        scale,
        contentUrl,
        contentType,
        fixedSize,
        fitToWindow
      }
    }
  `,

  myTeams: gql`
    query MyTeams ($userRole: String) {
      myTeams(userRole: $userRole) {
        teamId,
        name,
        defaultClusterId,
        roomCount,
        members {
          email,
          memberRole
        },
        rooms {
          roomId,
          name
        }
      }
    }
  `,

  allTeams: gql`
    query {
      allTeams {
        teamId,
        defaultClusterId
        name
      }
    }
  `,

  teamInfo: gql`
    query TeamInfo ($teamId: ID!) {
      teamInfo(teamId: $teamId) {
        teamId,
        name,
        orchestratorUrl,
        orchestratorPort,
        sessionPortRangeStart,
        sessionPortRangeEnd,
        orchestratorUsername,
        orchestratorPassword,
        defaultClusterId,
        defaultOrchestratorId,
        streamingServerUrl,
        teamTier,
        teamCreatedTimestamp,
        members {
          email,
          memberRole,
          invitationStatus,
          userCreatedTimestamp
        },
        rooms {
          roomId,
          name
        },
        clusters {
          clusterId,
          name,
          permission
        }
      }
    }
  `,

  myRooms: gql`
    query myRooms($teamId: ID, $first: Int, $offset: Int) {
      myRooms (teamId: $teamId, first: $first, offset: $offset) {
        roomId,
        name,
        serverKey,
        thumbnailUrl,
        team {
          teamId,
          name
        },
        totalNumberOfRooms,
        session {
          startDate
          participants
          sessionState
        }
      }
    }
  `,

  roomInfo: gql`
    query RoomInfo ($roomId: ID!) {
      roomInfo(roomId: $roomId) {
        roomId,
        name,
        ip,
        port,
        sceneName,
        sceneUrl,
        serverKey,
        invitees,
        logicServerId,
        mqServerId,
        sessionServicesVersion,
        orchestratorUsername,
        orchestratorPassword,
        orchestratorId,
        orchestratorName,
        assetId,
        assetName,
        sessionStatus,
        thumbnailUrl,
        streamingServerUrl
      }
    }
  `,

  myMeetings: gql`
    query {
      myMeetings {
        meetingId
        title
        startDate
        endDate
        endTimeSpecified
      }
    }
  `,

  mySettings: gql`
    query {
      mySettings {
        email
        emailVerified
        username
        nickname
      }
    }
  `,

  meetingInfo: gql`
    query MeetingInfo($meetingId: ID!) {
      meetingInfo(meetingId: $meetingId) {
        meetingId
        title
        description
        startDate
        endDate
        endTimeSpecified
      }
    }
  `
}

export default queries
